export const API_ROUTES = {
  authentication: {
    signIn: 'authentication/signin',
    renew: 'authentication/renew',
    signUp: 'authentication/signup',
    signOut: 'authentication/signout',
    signOutAll: 'authentication/signoutall',
    addAdfsIdentity: 'authentication/addadfsidentity',
    getAdfsRedirectUrl: 'authentication/getadfsredirecturl',
    getAuthenticationTypes: 'authentication/getauthenticationtypes',
  },
  contact: {
    create: 'contact/create',
    update: 'contact/update',
    delete: 'contact/delete',
    get: 'contact/get',
    getForAccount: 'contact/getforaccount',
    deleteForAccount: 'contact/deleteforaccount',
    search: 'contact/searchformailaccount',
    exportExcel: 'contactexport/exportexcel',
    exportVsCard: 'contactexport/exportvcard',
    getSearchCounter: 'contact/getsearchcountformailaccount',
    saveTags: 'contacttag/savetags',
  },
  importContacts: {
    import: 'contactimport/import',
    getImportTemplate: 'contactimport/getimporttemplate',
  },
  attachment: {
    get: 'attachment/getlistbyemailid',
  },
  contactGroup: {
    create: 'contactgroup/create',
    update: 'contactgroup/update',
    delete: 'contactgroup/delete',
    get: 'contactgroup/get',
    getForAccount: 'contactgroup/getforaccount',
    deleteForAccount: 'contactgroup/deleteforaccount',
    addContactsToGroup: 'contactgroup/addcontactstogroup',
    removeContactsFromGroup: 'contactgroup/removecontactsfromgroup',
    getGroupContacts: 'contactgroup/getgroupcontacts',
    removeContactsFromAllGroups: 'contactgroup/removecontactsfromallgroups',
  },
  claim: {
    getForAccount: 'claim/getforaccount',
    createOrUpdate: 'claim/createorupdate',
    getRtaClaimByOrganizationId: 'claim/getrtaclaimbyorganizationid',
    createOrUpdateRtaClaimByOrganizationId:
      'claim/createorupdatertaclaimfororganization',
  },
  email: {
    search: 'email/search',
    searchByWidget: 'email/searchbywidget',
    get: 'email/getbyid',
    getNotifications: 'email/getnotifications',
    createDraft: 'email/createdraft',
    update: 'email/update',
    markForSend: 'email/markforsend',
    reply: 'email/reply',
    replyAll: 'email/replyall',
    forward: 'email/forward',
    forwardMultiple: 'email/forwardmultiple',
    delete: 'email/delete',
    finalDelete: 'email/finaldelete',
    restore: 'email/restore',
    setIsSpam: 'email/setisspam',
    setNotSpam: 'email/setnotspam',
    setSeen: 'email/setseen',
    move: 'email/move',
    reassign: 'email/reassign',
    setValidation: 'email/setvalidation',
    readyToValidate: 'email/readytovalidate',
    validationApprove: 'email/validationapprove',
    validationReject: 'email/validationreject',
    download: 'email/download',
    singleDownload: 'email/singledownload',
    downloadAllAttachments: 'email/downloadattachments',
    archive: 'email/archive',
    restoreFromArchive: 'email/restoreFromArchive',
    retrySend: 'email/retrysend',
    setStarred: 'email/setstarred',
    reSetStarred: 'email/resetstarred',
    moveToDraft: 'email/movetodraft',
    archiving: 'email/resetarchivesession',
  },
  emailTag: {
    saveTags: 'emailtag/savetags',
    getEmailTags: 'emailtag/getemailtags',
  },
  ferreroPlugin: {
    create: 'ferreroplugin/create',
  },
  group: {
    create: 'group/create',
    update: 'group/update',
    delete: 'group/delete',
  },
  emailGroup: {
    addEmailsToGroups: 'emailgroup/addemailstogroups',
    removeEmailsFromGroups: 'emailgroup/removeemailsfromgroups',
    getGroupsForEmails: 'emailgroup/getforemails',
  },
  emailAudit: {
    getByEmail: 'emailaudit/getbyemail',
  },
  emailExport: {
    exportExcel: 'emailexport/exportexcel',
  },
  emailNote: {
    get: 'emailnote/get',
    getForEmail: 'emailnote/getforemail',
    create: 'emailnote/create',
    update: 'emailnote/update',
    delete: 'emailnote/delete',
  },
  emailFile: {
    create: 'emailfile/create',
    get: 'emailfile/get',
    getMeta: 'emailfile/getmeta',
    multipleCreate: 'emailfile/multiple-create',
  },
  tempFile: {
    get: 'tempfile/get',
    getMeta: 'tempfile/getmeta',
  },
  groupSettings: {
    getForOrganization: 'group/getfororganization',
    create: 'group/create',
    update: 'group/update',
    delete: 'group/delete',
    getSearchCounter: 'group/getsearchcounter',
    exportExcel: 'group/exportexcel',
  },
  importSession: {
    create: 'importsession/create',
    getByOrganizationId: 'importsession/getbyorganizationid',
  },
  importSessionResource: {
    getByImportSessionId: 'importsessionresource/getbyimportsessionid',
  },
  logging: {
    create: 'log/create',
  },
  mailAccount: {
    getAll: 'mailaccount/getall',
    getForReassign: 'mailaccount/getforreassign',
    get: 'mailaccount/get',
    getByOrganizationId: 'mailaccount/getbyorganizationid',
    create: 'mailaccount/create',
    update: 'mailaccount/update',
    updatePassword: 'mailaccount/updatepassword',
    delete: 'mailaccount/delete',
    getSearchCount: 'mailaccount/search/getcount',
    getSearch: 'mailaccount/search',
    getOrganizationMailAccounts: 'mailaccount/getorganizationmailaccounts',
    getMailAccountsBadges: 'mailaccount/getmailaccountsbadges',
    exportExcel: 'mailaccount/exportexcel',
  },
  mailAccountSettings: {
    getByMailAccount: 'mailaccountsettings/getbymailaccount',
    update: 'mailaccountsettings/createorupdate',
  },
  mailAccountSimpleConfiguration: {
    canSetup: 'mailaccountsimpleconfiguration/cansetup',
    create: 'mailaccountsimpleconfiguration/create',
  },
  dispatchingRule: {
    getForAccount: 'dispatchingrule/getforaccount',
    searchForAccount: 'dispatchingrule/seatchforaccount',
    getSearchForAccountCount: 'dispatchingrule/getseatchforaccountcount',
    getAvailableDataForAccount: 'dispatchingrule/getavailabledataforaccount',
    get: 'dispatchingrule/get',
    create: 'dispatchingrule/create',
    update: 'dispatchingrule/update',
    delete: 'dispatchingrule/delete',
    exportExcel: 'dispatchingrule/exportexcel',
  },
  mailFolder: {
    get: 'mailfolder/get',
    getForReassign: 'mailfolder/getforreassign',
    getAll: 'mailfolder/getall',
    create: 'mailfolder/create',
    update: 'mailfolder/update',
    delete: 'mailfolder/delete',
    getForAccount: 'mailfolder/getforaccount',
    getForMailAccountFlat: 'mailfolder/getforaccountflat',
    getDefault: 'mailfolder/getdefault',
    getUnreadCount: 'mailfolder/getunreadcount',
    getFolderUnreadCount: 'mailfolder/getfolderunreadcount',
    getUserFolders: 'mailfolder/getuserfolders',
  },
  mailFolderSettings: {
    getByMailFolder: 'mailfoldersettings/getbymailfolder',
    createOrUpdate: 'mailfoldersettings/createorupdate',
  },
  massiveSend: {
    getForMailAccount: 'massivesend/getformailaccount',
    status: 'massivesend/status',
    startXlsx: 'massivesend/startxlsx',
  },
  organization: {
    get: 'organization/get',
    search: 'organization/search',
    getSearchCount: 'organization/search/getcount',
    create: 'organization/create',
    update: 'organization/update',
    delete: 'organization/delete',
    getOrganizationName: 'organization/getorganizationname',
    getAvailableParentOrganizations:
      'organization/getavailableparentorganizations',
  },
  organizationSettings: {
    getByOrganization: 'organizationsettings/getbyorganization',
    createOrUpdate: 'organizationsettings/createorupdate',
    getOrganizationsWithAdfs: 'organizationsettings/getOrganizationswithadfs',
  },
  password: {
    update: 'password/update',
  },
  permission: {
    get: 'permission/get',
  },
  provider: {
    getAll: 'provider/getall',
    getByOrganization: 'provider/getbyorganization',
    search: 'provider/search',
    get: 'provider/get',
    create: 'provider/create',
    update: 'provider/update',
    delete: 'provider/delete',
  },
  remote: {
    fetchRemoteFolders: 'remote/fetchremotefolders',
  },
  report: {
    exportExcel: 'report/exportexcel',
  },
  searchWidget: {
    createOrUpdate: 'searchwidget/createorupdate',
    get: 'searchwidget/get',
    getAll: 'searchwidget/getAll',
    delete: 'searchwidget/delete',
  },
  statistic: {
    organization: 'statistic/organization',
  },
  tag: {
    getForMailAccount: 'tag/getformailaccount',
    getForEmail: 'tag/getforemail',
    getList: 'tag/getlist',
    getAll: 'tag/getall',
    searchForMailAccount: 'tag/searchformailaccount',
    getSearchCountForMailAccount: 'tag/getsearchcountformailaccount',
    insert: 'tag/insert',
    update: 'tag/update',
    delete: 'tag/delete',
    exportExcel: 'tag/exportexcel',
  },
  template: {
    getForMailAccount: 'template/getformailaccount',
    searchForMailAccount: 'template/searchformailaccount',
    getSearchCountForMailAccount: 'template/getsearchcountformailaccount',
    create: 'template/create',
    update: 'template/update',
    getById: 'template/getbyid',
    delete: 'template/delete',
    exportExcel: 'template/exportexcel',
  },
  userIdentity: {
    getForUser: 'useridentity/getforuser',
  },
  userMailAccount: {
    addMailAccountUser: 'usermailaccount/addmailaccountuser',
    deleteMailAccountUser: 'usermailaccount/deletemailaccountuser',
    assignRole: 'usermailaccount/assignrole',
    getUserAccountsById: 'usermailaccount/getuseraccountsbyid',
    getMailAccountUsers: 'usermailaccount/getmailaccountusers',
    getUserMailAccountRoles: 'usermailaccount/getusermailaccountroles',
    getUsers: 'usermailaccount/getusers',
    get: 'usermailaccount/get',
    getLoggedUserAccounts: 'usermailaccount/getloggeduseraccounts',
    searchMailAccountUsers: 'usermailaccount/searchmailaccountusers',
    getSearchMailAccountUsersCount:
      'usermailaccount/getsearchmailaccountuserscount',
    setUserMailAccounts: 'usermailaccount/setusersmailaccounts',
    setMailAccountUsers: 'usermailaccount/setmailaccountsusers',
    exportExcel: 'usermailaccount/exportexcel',
  },
  userOrganization: {
    getOrganizationUsers: 'userorganization/getorganizationusers',
    getUserOrganizations: 'userorganization/getuserorganizations',
    deleteUserFromOrganization: 'userorganization/deleteuserfromorganization',
    search: 'userorganization/search',
    getSearchCount: 'userorganization/getsearchcount',
    addUserToOrganization: 'userorganization/addusertoorganization',
    updateUser: 'userorganization/update',
    changeRole: 'userorganization/changerole',
    changeState: 'userorganization/changestate',
    getAvailableUsers: 'usermailaccount/getavailableusers',
    getUserIdentityTypes: 'useridentity/getuseridentitybyuserid',
    getIdentityOidcByUserIdentityId:
      'useridentity/getidentityoidcbyuseridentityid',
    exportExcel: 'userorganization/exportexcel',
  },
  fe: {
    version: 'version',
  },
  user: {
    getUser: 'user/getuser',
    update: 'user/update',
    setLastOrganization: 'user/setlastorganization',
  },
  userGroup: {
    setUsersGroups: 'usergroup/setusersgroups',
    setGroupsUsers: 'usergroup/setgroupsusers',
    getUserGroups: 'usergroup/getusergroups',
    getGroupUsers: 'usergroup/getgroupusers',
  },
  importEML: {
    upload: 'importeml/upload',
    import: 'importeml/import',
  },
  dispatching: {
    dispatchforaccount: 'dispatching/dispatchforaccount',
  },
};
